import React__default from 'react';
import '../../utils/createContextUtilities/index.js';
import createContextUtilities from '../../utils/createContextUtilities/createContextUtilities.js';

const {
  Provider,
  useContext: usePortalTarget
} = createContextUtilities(typeof window !== 'undefined' ? document.body : null);
const PortalTargetProvider = _ref => {
  let {
    target = null,
    children
  } = _ref;
  return /*#__PURE__*/React__default.createElement(Provider, {
    value: target
  }, children);
};

export { PortalTargetProvider, usePortalTarget };
